import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';

class UsersExport extends Component{
	render(){
		return (
			<p>
				<button className="button is-small is-inm-purple" onClick={() => this._getExport()}><b>Exportar</b></button>
			</p>
		)
	}

	constructor(){
		super();
		this._getExport = this._getExport.bind(this);
	}

	_getExport(){
		const { users } = this.props;
		this.props.usersExport(users.filters);
	}
}

export default SecureLayout(UsersExport);


// WEBPACK FOOTER //
// ./src/elements/users/widget/users_export.jsx